
import { IVeriMapChildComponent, IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import * as angular from "angular";
import { IAutocompleteMatch } from "../../_forms/autocomplete/autocomplete.component";
import "./mapControls.scss";

interface IVeriMapControlsComponentBindings {
    fitMap: Function;
    includeVehicleSearch: boolean;
    showSearch: boolean;
    map: google.maps.Map;
}

class ComponentController implements angular.IComponentController, IVeriMapChildComponent, IVeriMapControlsComponentBindings {

    veriMap: IVeriMapComponent;

    fitMap: Function;
    includeVehicleSearch: boolean;
    showSearch: boolean;
    map: google.maps.Map;
    marker: google.maps.Marker;

    static $inject = ["$element"];

    constructor(private $element: angular.IAugmentedJQuery) {
    }

    $onInit() {
        this.veriMap.registerChildComponent(this);
    }

    onMapLoad() {
        this.map = this.veriMap.getMap();
        this.initSearchBox(this.map, this.$element);
    }

    selectedMatchChange(match: IAutocompleteMatch) {
        if (!match) {
            // This will clear when a user types, currently disabled
            ////this.clearExistingMarker();
            return;
        }

        const latLng = new google.maps.LatLng(match.location.lat, match.location.lng);

        this.veriMap.smoothPanAndZoomTo(latLng, 14);

        //var kmlLayer = new google.maps.KmlLayer("", {
        //    suppressInfoWindows: true,
        //    preserveViewport: false,
        //    map: this.veriMap.getMap()
        //});

        //this.$scope.map.panTo(latLng);
        //const currentZoom = this.$scope.map.getZoom();
        //const zoomPreference = 13;

        //if (currentZoom < zoomPreference) {
        //    this.$scope.map.setZoom(zoomPreference);
        //}

        if (match.source.toLowerCase() === "place") {
            this.clearExistingMarker();

            this.marker = new google.maps.Marker({
                position: latLng,
                map: this.veriMap.getMap(),
                title: match.label,
                label: match.label
            });

            this.marker.addListener('dblclick', () => {
                this.clearExistingMarker();
            });

            this.marker.addListener('rightclick', () => {
                this.clearExistingMarker();
            });
        }
    }

    private clearExistingMarker() {
        if (this.marker) {
            this.marker.setMap(null);

            this.marker = null;
        }
    }

    private initSearchBox(map: google.maps.Map, $element: angular.IAugmentedJQuery) {
        var position = this.veriMap.showControlsOnRight ? google.maps.ControlPosition.TOP_RIGHT : google.maps.ControlPosition.TOP_LEFT;
        map.controls[position].push($element[0]);
    }
}

export class VeriMapControlsComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    transclude: { [slot: string]: string } | boolean;
    require: { [index: string]: string; };

    constructor() {
        this.bindings = {
            includeVehicleSearch: "<",
            showSearch: "<",
            hideFitMap: "<",

            fitMap: "&"
        };

        this.require = {
            veriMap: "^veriMap"
        };

        this.transclude = true;
        this.controller = ComponentController;
        this.template = require("./mapControls.html");
    }
}
